<div class="flex flex-col gap-2">
  <div class="bg-white p-4">
    <div>
      <div>Tu gestor comercial</div>
      <div>Name Surname</div>
    </div>
  </div>
  <div class="bg-neutral-300 p-4">
    <div>
      <div>Autorizar asistencia</div>
    </div>
  </div>
</div>
